"use client";

import { useCallback } from "react";
import en from "./en.json";

type Keys<T> = { [K in keyof T & string]: T[K] extends string ? K : `${K}.${Keys<T[K]>}` }[keyof T & string];
export type TranslationKey = Keys<typeof en>;

export function useTranslation() {
  const t = useCallback((key: TranslationKey, values: Record<string, string | number> = {}): string => {
    const text = key.split(".").reduce<any>((value, part) => value[part], en) as string;
    return text.replace(/\{\{(\w+)\}\}/g, (match, name) => String(values[name] ?? match));
  }, []);
  return { t };
}
